// eslint-disable-next-line no-restricted-imports
import type { Moment } from 'moment';
// eslint-disable-next-line no-restricted-imports
import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';

const modifiedMoment = moment;
// There is a problem with the typing
// eslint-disable-next-line @typescript-eslint/no-explicit-any
momentDurationFormatSetup(modifiedMoment as any);

export type { Moment };

export { modifiedMoment as moment };
